// extracted by mini-css-extract-plugin
export default {"searchPageLoading":"SearchPageLoading_searchPageLoading__77mNx"};